// R2-G62 (boot double-load): the <Refine key> exists for cache isolation —
// a DIFFERENT user in the same tab must remount the whole Refine tree (fresh
// QueryClient, no cross-user cache reads). But authStore does NOT persist
// `user`, so every refresh boots with user=undefined and keying on the raw id
// flipped `refine-undefined` → `refine-<id>` when auth resolved, remounting
// the tree and re-running /get_user.json + every boot loader a second time.
//
// The key is therefore an EPOCH, not the id: unknown→known adopts the id
// silently (same session, no flip); a non-null id CHANGE bumps the epoch
// (login-as / switch-identity / org-user switch / logout→login as someone
// else). Logout alone (id→null) keeps the key — the anonymous surfaces never
// read user-scoped caches, and the next different-user login still flips.
// Same-user relogin freshness is NOT this key's job: authStore.logout()
// clears the surviving QueryClient (lib/reactQueryHelpers/activeQueryClient).
//
// Factory only — the live resolver instance is held in a useRef inside
// AppRefine (Providers.tsx), never module state.
export const createRefineKeyResolver = () => {
  let sessionUserId: string | number | null = null;
  let epoch = 0;
  return (userId: string | number | null | undefined): string => {
    if (userId != null) {
      // String-compare: the id may arrive as number (wire) or string (form).
      if (sessionUserId != null && String(sessionUserId) !== String(userId)) {
        epoch += 1;
      }
      sessionUserId = userId;
    }
    return `refine-${epoch}`;
  };
};
